import FeatureFlag from "../../types/FeatureFlag";
import {useAuth} from "../../context/AuthContext";
import {MapLayer} from "../../types/MapLayers";

// Constants ----

const allMapLayers: MapLayer[] = [
  MapLayer.BEACON,
  MapLayer.TRAIL,
  MapLayer.FACILITY,
  MapLayer.EXHIBIT,
  MapLayer.ZONE,
  MapLayer.SITE,
  MapLayer.BUILDING,
  MapLayer.INTERACTION_AREA,
]

// Hook ----

export function useMapLayers() {
  const {can, canUse} = useAuth();
  const buildingsEnabled = can('buildings:read') && canUse(FeatureFlag.IndoorMapping);

  const enabledMapLayers = allMapLayers.filter(mapLayer => {
    switch(mapLayer) {
      case MapLayer.BUILDING:
        return buildingsEnabled;
      default:
        return true;
    }
  })

  return { enabledMapLayers }
}